import React from "react";
import * as C from "components";
import { v4 as uuidV4 } from "uuid";

export const images = [
  { component: <C.Slide1 key={uuidV4()} /> },
  { component: <C.Slide2 key={uuidV4()} /> },
  { component: <C.Slide3 key={uuidV4()} /> },
  { component: <C.Slide4 key={uuidV4()} /> },
  { component: <C.Slide5 key={uuidV4()} /> },
  { component: <C.Slide6 key={uuidV4()} /> },
  { component: <C.Slide7 key={uuidV4()} /> },
  { component: <C.Slide8 key={uuidV4()} /> },
  { component: <C.Slide9 key={uuidV4()} /> },
  { component: <C.Slide10 key={uuidV4()} /> },
  { component: <C.Slide11 key={uuidV4()} /> },
  { component: <C.Slide12 key={uuidV4()} /> },
  { component: <C.Slide13 key={uuidV4()} /> },
  { component: <C.Slide14 key={uuidV4()} /> },
];
